<template>
  <div>
    <Header>
      <template v-slot:left>
        <FeatherIcon icon="chevron-left" @click="onClickBack" />
      </template>
      退会アンケート
    </Header>
    <div class="mypage py-3">
      <div class="section px-3 pt-4 mt-2">
        <CustomValidationObserver ref="vObserver" v-slot="{ handleSubmit }">
          <BForm>
            <div class="bg-white border border-outline-color px-3 mt-1 round-4">
              <p class="text-mild text-size-26 text-weight-500 py-3">
                [{{ serviceName }}] 退会アンケート
              </p>
              <p class="text-size-12 py-3">
                この度はワークシェアサービス[{{
                  serviceName
                }}]をご利用いただき、心
                よりお礼申し上げます。貴方様のニーズを叶えられるように、今後も日々改
                善していきます。<br />
                今後のサービス運営の参考にさせていただきますので、以下のアンケートに
                ご協力いただけますと幸いです。
              </p>
            </div>
            <div
              class="bg-white border border-outline-color px-3 pb-3 mt-1 round-4"
            >
              <p class="text-mild text-size-21 text-weight-500 py-3">
                退会理由を選択してください
              </p>
              <AppLabel variant="red">必須</AppLabel>
              <ValidationProvider
                v-slot="validationState"
                name="退会理由"
                :rules="{ at_latest_one: inputValue.selectedLeaveReason }"
                vid="inputValue.selectedLeaveReason"
              >
                <ul>
                  <li
                    v-for="(option, index) in leaveReasons"
                    :key="option.id"
                    class="d-flex"
                  >
                    <AppCheckbox
                      v-model="inputValue.selectedLeaveReason[index]"
                      :id="`q1-option-${option.id}`"
                      name="退会理由"
                      class="mt-1 checkbox"
                      :text="option.text"
                    />
                  </li>
                </ul>
                <FormInvalidFeedback
                  :validation-state="validationState"
                  :state="false"
                />
              </ValidationProvider>
              <div
                class="m-2"
                v-show="isSelected(inputValue.selectedLeaveReason[6])"
              >
                <ValidationProvider
                  v-slot="validationState"
                  name="退会理由(その他)"
                  :rules="{
                    max: 20,
                    required: isSelected(inputValue.selectedLeaveReason[6])
                  }"
                  vid="inputValue.otherLeaveReason"
                >
                  <AppTextField
                    v-model="inputValue.otherLeaveReason"
                    name="退会理由(その他)"
                  />
                  <FormInvalidFeedback
                    :validation-state="validationState"
                    :state="false"
                  />
                </ValidationProvider>
              </div>
            </div>
            <div
              class="bg-white border border-outline-color px-3 mt-1 round-4 pb-2"
            >
              <p class="text-mild text-size-21 text-weight-500 py-3">
                当サービスにはどの程度ご満足いただけましたか？
              </p>
              <ValidationProvider
                v-slot="validationState"
                name="満足度"
                rules="required"
                vid="inputValue.selectedSatisfactionRate"
              >
                <FormRadioGroup
                  appLabelText="必須"
                  name="satisfaction-rate"
                  v-model="inputValue.selectedSatisfactionRate"
                  :options="satisfactionRate"
                  :validation-state="validationState"
                  size="small"
                  :has-border="false"
                  flex-direction="column"
                />
              </ValidationProvider>
            </div>
            <div
              class="bg-white border border-outline-color px-3 pb-2 mt-1 round-4"
            >
              <p class="text-mild text-size-21 text-weight-500 py-3">
                当社のサービスをどのように知りましたか？
              </p>
              <ValidationProvider
                v-slot="validationState"
                name="知った理由"
                rules="required"
                vid="inputValue.selectedKnewReason"
              >
                <FormRadioGroup
                  appLabelText="必須"
                  name="knew-reason"
                  v-model="inputValue.selectedKnewReason"
                  :options="knewReasons"
                  :validation-state="validationState"
                  size="small"
                  :has-border="false"
                  flex-direction="column"
                />
                <div
                  class="m-2"
                  v-show="inputValue.selectedKnewReason === '12'"
                >
                  <ValidationProvider
                    v-slot="validationState"
                    name="サービスを知った理由"
                    :rules="{
                      max: 20,
                      required: inputValue.selectedKnewReason === '12'
                    }"
                    vid="inputValue.otherKnewReason"
                  >
                    <AppTextField
                      v-model="inputValue.otherKnewReason"
                      name="サービスを知った理由"
                    />
                    <FormInvalidFeedback
                      :validation-state="validationState"
                      :state="false"
                    />
                  </ValidationProvider>
                </div>
              </ValidationProvider>
            </div>
            <div
              class="bg-white border border-outline-color px-3 pb-2 mt-1 round-4"
            >
              <p class="text-mild text-size-21 text-weight-500 py-3">
                {{
                  serviceName
                }}に対して今後のサービス改善のため、ご意見・ご要望をお書きください
              </p>
              <ValidationProvider
                v-slot="validationState"
                name="テキスト"
                :rules="{ max: 200, min: 20, required: true }"
                vid="inputValue.suggestionValue"
              >
                <TextAreaGroup
                  placeholder="20文字以上、200文字以内で入力してください"
                  appLabelText="必須"
                  v-model="inputValue.suggestionValue"
                  :validationState="validationState"
                />
              </ValidationProvider>
            </div>
            <div class="d-inline-flex w-100 justify-content-around">
              <AppButton
                class="mt-4 px-5"
                variant="danger"
                @click="handleSubmit(onClickSubmitButton)"
                >退会</AppButton
              >
              <AppButton class="mt-4 px-5" @click="backToMypage()"
                >戻る</AppButton
              >
            </div>
          </BForm>
        </CustomValidationObserver>
      </div>
    </div>
    <AppFooter />
    <BlockBack />
  </div>
</template>

<script lang="ts">
import { h } from "vue";
import { Component, Vue } from "vue-facing-decorator";
import Header from "@/components/organisms/common/Header.vue";
import AppFooter from "@/components/organisms/common/AppFooter.vue";
import BlockBack from "@/components/organisms/common/BlockBack.vue";
import TextAreaGroup from "@/components/molecules/form/TextAreaGroup.vue";
import AppButton from "@/components/atoms/button/AppButton.vue";
import AppCheckbox from "@/components/atoms/input/AppCheckbox.vue";
import FormRadioGroup from "@/components/molecules/form/FormRadioGroup.vue";
import AppTextField from "@/components/atoms/input/AppTextField.vue";
import { AccountService } from "@/app/services/v2/AccountService";
import { authStore } from "@/store/auth";
import { showErrorModal } from "@/utils/showErrorModal";
import { captureException } from "@/plugins/sentry";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import FormInvalidFeedback from "@/components/atoms/other/FormInvalidFeedback.vue";
import { sendAdjustEvent } from "@/plugins/adjust";
import { sendFirebaseCustomEvent } from "@/plugins/firebase";
import AppLabel from "@/components/atoms/input/AppLabel.vue";
import { APP_SERVICE_NAME_KANA } from "@/const/app";
import { routerPush } from "@/utils/routerPush";

@Component({
  components: {
    Header,
    AppLabel,
    FormRadioGroup,
    AppFooter,
    BlockBack,
    TextAreaGroup,
    AppCheckbox,
    AppButton,
    AppTextField,
    FeatherIcon,
    FormInvalidFeedback
  }
})
export default class LeavedQuestionnaire extends Vue {
  leaveReasons = [
    {
      id: 1,
      text: "希望勤務地エリアがなかった",
      value: 1
    },
    {
      id: 2,
      text: "希望日時の仕事がなかった",
      value: 2
    },
    {
      id: 3,
      text: "希望の仕事内容がなかった",
      value: 3
    },
    {
      id: 4,
      text: "未資格でできる仕事がない",
      value: 4
    },
    { id: 5, text: "給与が安い", value: 5 },
    {
      id: 6,
      text: "アプリの使い方が難しい",
      value: 6
    },
    {
      id: 7,
      text: "その他",
      value: 7
    }
  ];
  satisfactionRate = [
    { id: 1, text: "とても満足", value: 1 },
    { id: 2, text: "満足", value: 2 },
    { id: 3, text: "普通", value: 3 },
    { id: 4, text: "不満", value: 4 },
    { id: 5, text: "とても不満", value: 5 }
  ];
  knewReasons = [
    { id: 1, text: "Webメディア", value: 1 },
    { id: 2, text: "ネット広告", value: 2 },
    { id: 3, text: "SNS・ブログ", value: 3 },
    { id: 4, text: "知人・友人の紹介", value: 4 },
    { id: 5, text: "企業HP", value: 5 },
    { id: 6, text: "テレビ", value: 6 },
    { id: 7, text: "ラジオ", value: 7 },
    { id: 8, text: "新聞", value: 8 },
    { id: 9, text: "雑誌", value: 9 },
    { id: 10, text: "メルマガ", value: 10 },
    { id: 11, text: "交通広告・看板", value: 11 },
    { id: 12, text: "その他", value: 12 }
  ];
  inputValue = {
    selectedLeaveReason: [...Array(this.leaveReasons.length)].map(() => false),
    selectedSatisfactionRate: undefined,
    selectedKnewReason: undefined,
    suggestionValue: "",
    otherLeaveReason: "",
    otherKnewReason: ""
  };

  get serviceName() {
    return APP_SERVICE_NAME_KANA;
  }

  async created() {
    await sendAdjustEvent("SHOW_LEAVE_QUESTIONNAIRE");
    sendFirebaseCustomEvent("show_leave_questionnaire", {
      username: authStore.user?.username || "unknown"
    });
  }

  async showLeavedModal() {
    try {
      const message = [
        "退会処理が完了しました。",
        "今までカイテクをご利用いただきまして、誠にありがとうございました。"
      ].map(text => h("p", text));
      await this.$bvModal.msgBoxOk(message, {
        centered: true
      });
      await authStore.logout();
      await this.$router.replace({ name: "Welcome" });
    } catch (err) {
      await showErrorModal(this, err as Error);
    } finally {
      this.$loading.hide();
    }
  }

  backToMypage() {
    routerPush(this, { name: "Mypage" });
  }

  isSelected(value: boolean) {
    return value === true;
  }

  toNumber(value: string | undefined): number {
    if (!isNaN(Number(value))) {
      return Number(value);
    } else {
      throw Error("正しい値が入力されていません");
    }
  }

  async leave() {
    const answer02 = this.toNumber(this.inputValue.selectedSatisfactionRate);
    const answer03 = this.toNumber(this.inputValue.selectedKnewReason);

    /* eslint-disable @typescript-eslint/naming-convention */
    await AccountService.leave({
      serviceName: authStore.workerService.oldAppName, // TODO: 一旦データ継続性のため、過去データと同じ値を登録する形とする。将来的にはDBに登録する値自体を見直す必要がある
      answer01_01: this.inputValue.selectedLeaveReason[0],
      answer01_02: this.inputValue.selectedLeaveReason[1],
      answer01_03: this.inputValue.selectedLeaveReason[2],
      answer01_04: this.inputValue.selectedLeaveReason[3],
      answer01_05: this.inputValue.selectedLeaveReason[4],
      answer01_06: this.inputValue.selectedLeaveReason[5],
      answer01_other: this.inputValue.otherLeaveReason,
      answer02: answer02,
      answer03: answer03,
      answer03_other: this.inputValue.otherKnewReason,
      answer04: this.inputValue.suggestionValue
    });
    await sendAdjustEvent("FINISH_LEAVE");
    sendFirebaseCustomEvent("finish_leave", {
      username: authStore.user?.username || "unknown"
    });
  }

  async onClickSubmitButton() {
    await sendAdjustEvent("CONFIRM_LEAVE");
    sendFirebaseCustomEvent("confirm_leave", {
      username: authStore.user?.username || "unknown"
    });
    try {
      this.$loading.show();
      await this.leave();
      await this.showLeavedModal();
    } catch (err) {
      captureException(err as Error);
      await showErrorModal(this, err as Error);
    } finally {
      this.$loading.hide();
    }
  }

  async onClickBack() {
    await routerPush(this, { name: "LeaveConfirmation" });
  }
}
</script>

<style lang="scss" scoped>
.mypage {
  position: relative;

  .section {
    // iPhone のノッチ対応
    padding-top: env(safe-area-inset-top, 0);
  }
}

:deep(.radio-group__item) {
  margin: 6px 8px 0;
}
</style>
